export default function ChamUpload() {

    return(
        <cham-upload-button></cham-upload-button>
    );
}

export function ChamUploadButton({className, title}) {

    const handleClick = function() {
        document.querySelector("cham-upload-button").click();
    }

    return(
        <button onClick={handleClick} className={className}>{title}</button>
    )
}